export default __webpack_public_path__ + "static/media/chinasa.1f315ec3.jpg";